import { useCallback, useEffect, useRef, useState } from "react";
import NewSelectAuto from "../NewSelectAuto";
import { infiniteScrollHook } from "../../../hooks/infiniteScrollHook";
import {
  EntityType,
  LeaseAgreementDataAttributesEnum,
  LeaseAgreementService,
  LeaseAgreementStatusTypesEnum,
  OrganizationService,
  PaidFlowTypesEnum,
  PaymentService,
  PaymentTypesEnum,
  TemplateService,
  TemplateTypeEnum,
  TenantLeaseTypesEnum,
} from "@propertelligent/client-api";
import useInfiniteScroll from "react-infinite-scroll-hook";
import apiHelper from "../../../utils/apiHelper";
import DynamicAddMoreForm from "../../common/DynamicAddMoreForm";
import { convertENUMtoJSONArray } from "../../../utils/helper";
import { FORM_CONTROLFIELD_TYPES } from "../../../constants/constants";
import CustomInputs from "../../common/Inputs";
import { useError } from "../../../utils/context/ErrorContext";
import {
  Accordion,
  AccordionSection,
} from "../../../newComponents/card/accordion";
import SimpleButton from "../../../newComponents/buttons/Simple-button";
import AddTraspButton from "../../firstTimeUserExperience/commonCom/AddTraspButton";
import ShowLeaseAgreement from "./ShowLeaseAgreement";
import { UserLoginData } from "../../common/charts/Enums";
import { PubSub, TopicsEnum, NotificationType } from "../../../utils/pubsub";
import DateHelper from "../../../utils/DateHelper";
import LeaseOverlapModal from "../../../newComponents/tenant/LeaseOverlapModal";
interface AccordionState {
  leaseagreement: boolean;
  securityDeposit: boolean;
  preview: boolean;
}

const initialAccordionState: AccordionState = {
  leaseagreement: true,
  securityDeposit: false,
  preview: false,
};
const DUE_DAY_MIN = 1;
const DUE_DAY_MAX = 28;
const LeaseAgreementSettings = ({
  userData,
  setPreviewLeaseAgreement,
  selectedTemplateid,
  setSelectedTemplateid,
  setPostLeaseAgreement,
  //  formData, setFormData,
  setIsPrint = undefined,
  leaseApplicationId = null,
  postLeaseAgreement,
}) => {
  const orgId = parseInt(sessionStorage.getItem(UserLoginData.organization_id));
  const [formData, setFormData] = useState([
    {
      id: 1,
      paymentType: "",
      amount: undefined,
      dueDate: "",
      gracePeriods: undefined,
      description: "",
      isNonRefundable: false,
    },
  ]);

  const [selectedOption, setSelectedOption] = useState();
  const [templateError, setTemplateError] = useState(false);
  const [filteredInputs, setFilteredInputs] = useState([]);
  const [leaseType, setLeaseType] = useState();
  const [leaseTypeError, setLeaseTypeError] = useState(false);
  const [mandatoryFields, setMandatoryFields] = useState([
    "Rent",
    "SecurityDeposit",
    "UnitAddress",
    "StartDate",
    "LeaseType",
  ]);
  const [isSaving, setIsSaving] = useState(false);
  const [leaseTypesList, setLeaseTypesList] = useState([]);
  const [confirmforceUpdate, setConfirmForceUpdate] = useState(false);
  const [forceUpdate, setConfirmForce] = useState(false);
  const [isLeaseOverlapModalOpen, setIsLeaseOverlapModalOpen] = useState(false);
  const [existingLeaseData, setExistingLeaseData] = useState<any>({});
  const [isLoadingLeaseData, setIsLoadingLeaseData] = useState(false);

  const handleFetchExistingLease = (
    id: string | number,
    isId: boolean = false,
  ) => {
    setIsLoadingLeaseData(true);
    const serviceCall = isId
      ? LeaseAgreementService.getApiLeaseAgreement1
      : LeaseAgreementService.getApiLeaseAgreementUnitlist;

    apiHelper(
      serviceCall,
      { showNotification: false },
      Number(id),
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
    )
      .then((res) => {
        const data = res?.data?.success;
        const lease = Array.isArray(data) ? data[0] : data;
        setExistingLeaseData(lease?.formatted || {});
        setIsLoadingLeaseData(false);
      })
      .catch(() => {
        setIsLoadingLeaseData(false);
      });
  };
  const createdPaymentIdsRef = useRef<number[]>([]);
  const [accordionState, setAccordionState] = useState<AccordionState>(
    initialAccordionState,
  );
  const ref = useRef(null);
  const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } =
    useError();
  const dataAttribute = convertENUMtoJSONArray(
    LeaseAgreementDataAttributesEnum,
  );

  const InputArray = dataAttribute?.map((attribute) => ({
    id: attribute?.id,
    name: attribute?.name,
    labelText: attribute?.name.replace(/([A-Z])/g, " $1").trim(),
    type: /Period|Day|amount|deposit|fee|rent/i.test(attribute?.name)
      ? FORM_CONTROLFIELD_TYPES.INTEGER
      : /Date/i.test(attribute?.name)
        ? FORM_CONTROLFIELD_TYPES.DATE
        : FORM_CONTROLFIELD_TYPES.TEXT,
    value: formData[attribute?.name],
    isFormControl: true,
    onChange: (e) => {
      handleChange(attribute?.name, e.target.value);
    },
    placeholder: `Enter ${attribute?.name.replace(/([A-Z])/g, " $1").trim()}`,
    myClassName: "containerTextField",
    isError: false,
    ref: ref,
    errorMessages: errorMessages[attribute?.name],
    currencySymbol: /amount|deposit|fee|rent/i.test(attribute?.name)
      ? "$"
      : undefined,
  }));

  const handleChange = useCallback(
    (fieldName, value) => {
      let newValue = String(value);
      if (fieldName === "LessorName" || fieldName === "LesseeName") {
        newValue = newValue.replace(/[^a-zA-Z ]/g, "");
      }
      if (fieldName === "DueDay") {
        const stripped = newValue.replace(/\D/g, "");
        if (stripped.length > 2) return;
        const num = parseInt(stripped, 10);
        if (
          stripped !== "" &&
          (isNaN(num) || num < DUE_DAY_MIN || num > DUE_DAY_MAX)
        )
          return;
        newValue = stripped;
      }
      setFilteredInputs((prev) =>
        prev.map((item) =>
          item.name === fieldName ? { ...item, value: newValue } : item,
        ),
      );
      setFormData((prevFormData) =>
        prevFormData.map((item) =>
          item[fieldName] !== undefined
            ? { ...item, [fieldName]: newValue }
            : item,
        ),
      );
      setPostLeaseAgreement((prevState) => {
        const updatedDataAttributes = {
          ...prevState.dataAttributes,
          [fieldName]: newValue,
        };
        if (
          fieldName === "LeaseType" &&
          Number(newValue) === TenantLeaseTypesEnum.MonthToMonth
        ) {
          delete updatedDataAttributes.EndDate;
        }
        return {
          ...prevState,
          templateId: selectedTemplateid,
          dataAttributes: updatedDataAttributes,
        };
      });

      if (fieldName === "LeaseType") {
        setLeaseType(value);
        setMandatoryFields((prevMandatoryFields) => {
          if (
            value === TenantLeaseTypesEnum.FixedTermLease &&
            !prevMandatoryFields.includes("EndDate")
          ) {
            return [...prevMandatoryFields, "EndDate"];
          } else if (value === TenantLeaseTypesEnum.MonthToMonth) {
            return prevMandatoryFields.filter((field) => field !== "EndDate");
          }
          return prevMandatoryFields;
        });
        setFilteredInputs((prevInputs) => {
          let updatedInputs = prevInputs.filter(
            (input) => input.name !== "EndDate",
          );

          if (value === TenantLeaseTypesEnum.FixedTermLease) {
            const endDateInput = InputArray.find(
              (input) => input.name === "EndDate",
            );
            if (endDateInput) {
              updatedInputs = [...updatedInputs, endDateInput];
            }
          }

          return updatedInputs;
        });
      }
      const errorKey = `inputFilter-${fieldName}`;
      setErrors((prevErrors) => ({ ...prevErrors, [errorKey]: false }));
      setErrorMessages((prevMessages) => ({ ...prevMessages, [errorKey]: "" }));
    },
    [leaseType],
  );

  const { loading, rows, fetchData, hasMore, currentPage } = infiniteScrollHook(
    {
      httpFetchDataFn: TemplateService.getApiTemplateOrganizationlist,
      FullyQualifiedFilters: `templateTypeId == ${TemplateTypeEnum.LeaseAgreement}`,
    },
  );

  const loadMoreRecords = () => {
    if (!loading) {
      fetchData(currentPage + 1);
    }
  };
  const [sentryRef] = useInfiniteScroll({
    loading: loading,
    hasNextPage: hasMore,
    onLoadMore: loadMoreRecords,
    rootMargin: "0px 0px 100px 0px",
  });

  const getTempleteData = () => {
    apiHelper(
      TemplateService.getApiTemplate,
      { showNotification: false },
      Number(selectedTemplateid),
    )
      .then((res) => {
        if (res?.data?.success) {
          const templateData = res.data.success;
          const uniqueAttributes = [
            ...new Set(
              templateData?.leaseAgreementTemplateSections?.flatMap(
                (section) => section.dataAttributes || [],
              ),
            ),
          ];
          const matchedInputs = InputArray?.filter(
            (input) =>
              uniqueAttributes.includes(input.id) ||
              mandatoryFields.includes(input.name),
          );
          setFilteredInputs(matchedInputs);
        }
      })
      .catch((err) => {
        console.error("Error fetching template data:", err);
      });
  };

  useEffect(() => {
    if (selectedTemplateid) {
      getTempleteData();
      setLeaseType(undefined);
    }
  }, [selectedTemplateid]);

  const checkEmptyFields = (validatePayments = false): boolean => {
    clearErrors();
    const newErrors: Record<string, boolean> = {};
    const newErrorMessages: Record<string, string> = {};
    let hasErrors = false;

    if (
      selectedTemplateid == null ||
      selectedTemplateid === "" ||
      selectedTemplateid === undefined
    ) {
      setTemplateError(true);
      hasErrors = true;
    } else {
      setTemplateError(false);
    }

    if (leaseType == null || leaseType === undefined) {
      setLeaseTypeError(true);
      hasErrors = true;
    } else {
      setLeaseTypeError(false);
    }

    filteredInputs?.forEach(({ name, labelText, value }) => {
      const errorKey = `inputFilter-${name}`;
      if (name === "DueDay") {
        const trimmed = value?.trim();
        if (!trimmed) {
          newErrors[errorKey] = true;
          newErrorMessages[errorKey] = `${labelText || name} is required`;
          hasErrors = true;
        } else {
          const num = parseInt(trimmed, 10);
          if (isNaN(num) || num < DUE_DAY_MIN || num > DUE_DAY_MAX) {
            newErrors[errorKey] = true;
            newErrorMessages[errorKey] =
              `Due Day must be between ${DUE_DAY_MIN} and ${DUE_DAY_MAX}`;
            hasErrors = true;
          } else {
            newErrors[errorKey] = false;
          }
        }
        return; // Skip default validation for DueDay
      }
      if (!value?.trim()) {
        newErrors[errorKey] = true;
        newErrorMessages[errorKey] = `${labelText || name} is required`;
        hasErrors = true;
      } else {
        newErrors[errorKey] = false;
      }

      // New: Validate DueDay range (1-28)
      if (name === "DueDay") {
        const dueDayValue = parseInt(value, 10);
        if (isNaN(dueDayValue) || dueDayValue < 1 || dueDayValue > 28) {
          newErrors[errorKey] = true;
          newErrorMessages[errorKey] =
            "Due Day must be a number between 1 and 28";
          hasErrors = true;
        }
      }
    });

    if (validatePayments) {
      formData?.forEach((payment, index) => {
        if (!payment?.dueDate) {
          newErrors[`dueDate-${index}`] = true;
          newErrorMessages[`dueDate-${index}`] = "Due date is required";
          hasErrors = true;
        } else {
          newErrors[`dueDate-${index}`] = false;
        }
        if (
          payment?.gracePeriods === undefined ||
          payment?.gracePeriods === ""
        ) {
          newErrors[`gracePeriods-${index}`] = true;
          newErrorMessages[`gracePeriods-${index}`] =
            "Grace period is required";
          hasErrors = true;
        } else {
          newErrors[`gracePeriods-${index}`] = false;
        }
        if (!payment?.amount) {
          newErrors[`amount-${index}`] = true;
          newErrorMessages[`amount-${index}`] = "Amount is required";
          hasErrors = true;
        } else {
          newErrors[`amount-${index}`] = false;
        }
        if (!payment?.description?.trim()) {
          newErrors[`description-${index}`] = true;
          newErrorMessages[`description-${index}`] = "Description is required";
          hasErrors = true;
        } else {
          newErrors[`description-${index}`] = false;
        }
        if (!payment?.paymentType) {
          newErrors[`paymentType-${index}`] = true;
          newErrorMessages[`paymentType-${index}`] = "Payment Type is required";
          hasErrors = true;
        } else {
          newErrors[`paymentType-${index}`] = false;
        }
      });
    }

    setErrors((prev) => ({ ...prev, ...newErrors }));
    setErrorMessages((prev) => ({ ...prev, ...newErrorMessages }));
    return hasErrors;
  };

  const getLeaseTypes = () => {
    apiHelper(LeaseAgreementService.getApiLeaseAgreementLeaseTypes, {
      showNotification: false,
    })
      .then((res) => {
        if (res?.data?.success) {
          setLeaseTypesList(res?.data?.success);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    clearErrors();
    getLeaseTypes();
  }, []);

  const toggleAccordion = useCallback(
    (section: keyof AccordionState) => {
      if (section === "securityDeposit" && !accordionState.preview) return;
      setAccordionState((prev) => ({
        ...prev,
        leaseagreement:
          section === "leaseagreement" ? !prev.leaseagreement : false,
        securityDeposit:
          section === "securityDeposit" ? !prev.securityDeposit : false,
        preview: section === "preview" ? !prev.preview : false,
      }));
    },
    [accordionState.preview],
  );

  const getPayeeAccountId = async (orgId) => {
    try {
      const res = await apiHelper(
        OrganizationService.getApiOrganizationFeeCommissions,
        { showNotification: false },
        orgId,
      );
      if (res?.data?.success) {
        return res?.data?.success?.securityDepositSetting?.depositAccountId;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  };
  const lowerFirstKey = (obj = {}) => {
    const result = {};
    for (const key in obj) {
      result[key[0].toLowerCase() + key.slice(1)] = obj[key];
    }
    return result;
  };

  const sendLeaseAgreement = async (isForceUpdate = false) => {
    setIsSaving(true);
    try {
      const payeeAccId = await getPayeeAccountId(orgId);
      let validPaymentIds: number[] = [];
      if (createdPaymentIdsRef.current.length > 0) {
        validPaymentIds = createdPaymentIdsRef.current;
      } else {
        const hasValidPayments = formData?.some(
          (item) => item?.amount && item?.paymentType,
        );

        if (hasValidPayments) {
          for (const item of formData) {
            if (!item?.amount || !item?.paymentType) continue;

            const res: any = await apiHelper(
              PaymentService.postApiPaymentDueAccount,
              {
                showNotification: true,
                failureMessage: "Unable to create payment account",
              },
              {
                amount: Number(item.amount),
                description: item.description,
                dueDate: item?.dueDate
                  ? new Date(item.dueDate).toISOString()
                  : null,
                entityId: Number(userData.id),
                entityTypeId: EntityType.Tenant,
                payeeAccountId: payeeAccId,
                gracePeriodInDays: Number(item.gracePeriods),
                paymentTypeId: Number(item.paymentType),
                paidFlowTypeId: PaidFlowTypesEnum.Receiveable,
                isNonRefundable: !!item.isNonRefundable,
              },
            );

            if (res?.data?.success?.id) {
              validPaymentIds.push(res.data.success.id);
            } else {
              setIsSaving(false);
              return;
            }
          }

          // ≡ƒöÉ cache ids
          createdPaymentIdsRef.current = validPaymentIds;
        }
      }

      const normalizedAttributes = lowerFirstKey(
        postLeaseAgreement?.dataAttributes || {},
      );
      const {
        tenantSignature,
        landlordSignature,
        leaseAgreementStatusTypeId,
        dataAttributes,
        unitId,
        ...filteredObject
      } = postLeaseAgreement;

      const {
        rent,
        endDate,
        startDate,
        securityDeposit,
        leaseType,
        ...restData
      } = normalizedAttributes as any;

      const leaseData = {
        ...filteredObject,
        startDate: startDate ? new Date(startDate) : undefined,
        endDate:
          Number(leaseType) === TenantLeaseTypesEnum.MonthToMonth
            ? undefined
            : endDate
              ? new Date(endDate)
              : undefined,
        rent: rent ? Number(rent) : undefined,
        securityDeposit: securityDeposit ? Number(securityDeposit) : undefined,
        leaseTypeId: leaseType ? Number(leaseType) : undefined,
        unitId: unitId || userData?.unitId,
        paymentDueAccountIds: validPaymentIds,
        templateId: selectedTemplateid,
        tenantId: userData.id,
        dataAttributes: restData,
        leaseApplicationId: Number(leaseApplicationId),
        prevoiusLeaseAgreementId: userData?.currentLeaseAgreementId || null,
        forceUpdate: isForceUpdate,
      };

      const response = await apiHelper(
        LeaseAgreementService.postApiLeaseAgreement,
        {
          successMessage: "Lease Agreement sent successfully",
          failureMessage: "Unable to Send Lease Agreement",
          showNotification: false,
        },
        leaseData,
      );
      if (response?.statusCode === 409) {
        const conflictEntityId = response?.errors?.ConflictEntityId?.[0];
        if (conflictEntityId && conflictEntityId !== "0") {
          handleFetchExistingLease(conflictEntityId, true);
          setIsLeaseOverlapModalOpen(true);
          return;
        } else {
          const errors = response?.errors || {};
          const otherErrorKey = Object.keys(errors).find(
            (k) =>
              k !== "ConflictEntityId" &&
              k !== "ConflictEntityTypeId" &&
              k !== "leaseAgreementId",
          );
          if (otherErrorKey) {
            PubSub.publish(TopicsEnum.Notification.toString(), {
              message: errors[otherErrorKey][0],
              type: NotificationType.Failure,
            });
          }
          return;
        }
      }
      if (response?.data?.success) {
        PubSub.publish(TopicsEnum.Notification.toString(), {
          message: "Lease Agreement sent successfully",
          type: NotificationType.Success,
        });
        PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), null);
      } else {
        console.warn(
          "Lease Agreement API failed (non-409):",
          JSON.stringify(response, null, 2),
        );
        // Show toast for non-409 errors (e.g. 400 Bad Request)
        if (response?.statusCode !== 409) {
          let errorMessage = "Unable to Send Lease Agreement";
          const respAny = response as any;
          if (respAny?.errors) {
            // Extract first error message
            const firstErrorKey = Object.keys(respAny.errors)[0];
            if (firstErrorKey && respAny.errors[firstErrorKey].length > 0) {
              errorMessage = respAny.errors[firstErrorKey][0];
            }
          } else if (respAny?.message) {
            errorMessage = respAny.message;
          }

          PubSub.publish(TopicsEnum.Notification.toString(), {
            message: errorMessage,
            type: NotificationType.Failure,
          });
        }
      }
    } catch (err: any) {
      if (err?.response?.status === 409 || err?.status === 409) {
        const conflictEntityId =
          err?.body?.errors?.ConflictEntityId?.[0] ||
          err?.response?.data?.errors?.ConflictEntityId?.[0];
        if (conflictEntityId && conflictEntityId !== "0") {
          handleFetchExistingLease(conflictEntityId, true);
          setIsLeaseOverlapModalOpen(true);
        } else {
          const errors = err?.body?.errors || err?.response?.data?.errors || {};
          const otherErrorKey = Object.keys(errors).find(
            (k) =>
              k !== "ConflictEntityId" &&
              k !== "ConflictEntityTypeId" &&
              k !== "leaseAgreementId",
          );
          if (otherErrorKey) {
            PubSub.publish(TopicsEnum.Notification.toString(), {
              message: errors[otherErrorKey][0],
              type: NotificationType.Failure,
            });
          }
        }
      } else {
        console.error("Lease Agreement API error:", err);
        // Show toast for non-409 errors caught here
        let errorMessage = "Unable to Send Lease Agreement";
        const errAny = err as any;
        if (errAny?.response?.data?.errors) {
          const firstErrorKey = Object.keys(errAny.response.data.errors)[0];
          if (
            firstErrorKey &&
            errAny.response.data.errors[firstErrorKey].length > 0
          ) {
            errorMessage = errAny.response.data.errors[firstErrorKey][0];
          }
        } else if (errAny?.message) {
          errorMessage = errAny.message;
        }

        PubSub.publish(TopicsEnum.Notification.toString(), {
          message: errorMessage,
          type: NotificationType.Failure,
        });
      }
    } finally {
      // ≡ƒöô ALWAYS release lock
      setIsSaving(false);
    }
  };

  return (
    <>
      <div className="leaseAgreementSettings_main">
        <div className="lease-agreement-setting-form">
          <Accordion>
            <AccordionSection
              title="Lease Agreement Template"
              isOpen={accordionState.leaseagreement}
              onToggle={() => toggleAccordion("leaseagreement")}
            >
              <div className="accordion-body">
                <div className="d-flex justify-content-between gap-3">
                  <div className="d-flex flex-column gap-2">
                    <NewSelectAuto
                      disabled={undefined}
                      setDisabled={undefined}
                      selected={selectedTemplateid}
                      setSelected={setSelectedTemplateid}
                      setSelectedOption={setSelectedOption}
                      selectedOption={selectedOption}
                      data={rows && rows}
                      title={"Wait till the data fetches"}
                      type="templete"
                      error={templateError}
                      setError={setTemplateError}
                      fromContractor={true}
                      label={"Select Lease template"}
                      errorMessage={errorMessages.template}
                    />

                    {selectedTemplateid && (
                      <>
                        {/* <div className='paymentSection '> */}
                        <div className="leaseagreementinput">
                          {filteredInputs?.map((item) => (
                            <div key={item.id}>
                              {item.labelText === "Lease Type" ? (
                                <NewSelectAuto
                                  disabled={undefined}
                                  setDisabled={undefined}
                                  selected={leaseType}
                                  setSelected={(value) =>
                                    handleChange(item.name, value)
                                  }
                                  // setSelectedOption={(value) => handleChange(item.name, value)}
                                  selectedOption={undefined}
                                  data={leaseTypesList}
                                  title={"Wait till the data fetches"}
                                  type="Lease Type"
                                  error={leaseTypeError}
                                  setError={setLeaseTypeError}
                                  errorMessage={errorMessages.leaseType}
                                  fromContractor={true}
                                  label={"Lease Type"}
                                  width={"100%"}
                                />
                              ) : (
                                <CustomInputs
                                  name={item.name}
                                  type={item.type}
                                  value={item.value}
                                  labelText={item.labelText}
                                  required={true}
                                  isFormControl
                                  onChange={item.onChange}
                                  placeholder={item.placeholder}
                                  myClassName={item.myClassName}
                                  currencySymbol={item?.currencySymbol}
                                  isError={errors[`inputFilter-${item.name}`]}
                                  errorMessages={
                                    errorMessages[`inputFilter-${item.name}`]
                                  }
                                  isCurrency={
                                    item?.currencySymbol ? true : false
                                  }
                                />
                              )}
                            </div>
                          ))}
                        </div>
                        {/* </div> */}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="footer-wrapper">
                <SimpleButton
                  type="button"
                  label="Next"
                  //  style={{ margin: 15, fontSize: 13 }}
                  onClick={
                    () => {
                      if (checkEmptyFields()) {
                        return;
                      }
                      setAccordionState({
                        leaseagreement: false,
                        securityDeposit: true,
                        preview: false,
                      });
                    }
                    //  handleNextClick
                  }
                />
              </div>
            </AccordionSection>
          </Accordion>
          <Accordion>
            <AccordionSection
              title="Security Deposit"
              isDisabled={!accordionState.preview}
              isOpen={accordionState.securityDeposit}
              // isOpen={true}
              onToggle={() => toggleAccordion("securityDeposit")}
            >
              <div className="accordion-body">
                <div className="paymentSection">
                  {/* <DisplayNamewithLeftBorder HeaderName={"Payments Required"} /> */}
                  <DynamicAddMoreForm data={formData} setData={setFormData} />
                </div>
              </div>
              <div className="footer-wrapper d-flex gap-2">
                <SimpleButton
                  type="button"
                  label="Preview Agreement"
                  onClick={() => {
                    if (checkEmptyFields(true)) {
                      return;
                    }
                    setAccordionState({
                      leaseagreement: false,
                      securityDeposit: false,
                      preview: true,
                    });
                  }}
                />
                <AddTraspButton
                  type="button"
                  bname={"Skip Deposit"}
                  onClick={
                    () =>
                      setAccordionState({
                        leaseagreement: false,
                        securityDeposit: false,
                        preview: true,
                      })

                    // if (checkEmptyFields()) { return; }
                    // { setPreviewLeaseAgreement(true) }
                  }
                  border={false}
                  width="fit-content"
                  disabled={undefined}
                  className={"addtrasparent"}
                  textclass={"normal_text fw-600 blue clickable"}
                />
              </div>
            </AccordionSection>
          </Accordion>
          <Accordion>
            <AccordionSection
              title="Preview"
              isDisabled={!accordionState.preview}
              isOpen={accordionState.preview}
              // isOpen={true}
              onToggle={() => toggleAccordion("preview")}
            >
              <div className="accordion-body">
                <ShowLeaseAgreement
                  leaseApplicationId={null}
                  isPreview={false}
                  userData={userData}
                  selectedTemplateid={selectedTemplateid}
                  postLeaseAgreement={postLeaseAgreement}
                  setPostLeaseAgreement={setPostLeaseAgreement}
                  onClick={() => {
                    sendLeaseAgreement();
                  }}
                  onCancel={() => {
                    setPreviewLeaseAgreement(false);
                  }}
                  role={"landlord"}
                  // buttonName={isLoading ? "Saving..." : ((currentLeaseInfo?.leaseAgreementStatusTypeId === LeaseAgreementStatusTypesEnum.PendingLandlordSignature) || (currentLeaseInfo?.leaseAgreementStatusTypeId === LeaseAgreementStatusTypesEnum.PendingTenantSignature)) ? "Next" : "Send Agreement"}
                  buttonName={"Send"}
                  selectedTemplates={undefined}
                  showHeader={false}
                />
              </div>
              <div className="footer-wrapper">
                <SimpleButton
                  type="button"
                  label="Send Agreement"
                  style={{ margin: 15, fontSize: 13 }}
                  onClick={() => {
                    // if (checkEmptyFields()) { return; }
                    sendLeaseAgreement();
                  }}
                />
              </div>
            </AccordionSection>
          </Accordion>
        </div>
      </div>
      {isLeaseOverlapModalOpen && (
        <LeaseOverlapModal
          isOpen={isLeaseOverlapModalOpen}
          onClose={() => {
            setIsLeaseOverlapModalOpen(false);
            setConfirmForce(false);
          }}
          onContinue={() => {
            // Keep modal open to show loading state
            setConfirmForce(true);
            sendLeaseAgreement(true);
          }}
          existingLease={{
            type: existingLeaseData?.LeaseTypeId,
            startDate: existingLeaseData?.StartDateDateOnly,
            endDate: existingLeaseData?.EndDateDateOnly,
            securityDeposit: existingLeaseData?.SecurityDeposit,
            securityDepositRaw: existingLeaseData?.SecurityDepositRaw,
            rent: existingLeaseData?.Rent,
            rentRaw: existingLeaseData?.RentRaw,
          }}
          newLeaseEndDate={DateHelper.getPreviousDay(
            String(postLeaseAgreement?.dataAttributes?.StartDate || "") || "",
          )}
          isLoading={isLoadingLeaseData || isSaving}
        />
      )}
    </>
  );
};
export default LeaseAgreementSettings;
